<template>
  <div class="flex flex-col items-between gap-4 mx-16 md:m-4">
    <TitreDeux :content="t('createBrand')" />
    <InputField :placeholder="t('brandName')" v-model="newName" />
    <BlueButton :text="t('addAction')" @click="createMarque" />
  </div>
</template>

<script setup>

import {t} from "@/utils/Traduction";
import BlueButton from "@/components/molecules/BlueButton.vue";
import InputField from "@/components/molecules/InputField.vue";
import {ref} from "vue";
import {NotificationStores} from "@/stores/NotificationStores";
import {MarqueStore} from "@/stores/MarqueStore";
import TitreDeux from "@/components/atoms/TitreDeux.vue";

const notificationStores = NotificationStores();
const marqueStore = MarqueStore();

const newName = ref("");

const createMarque = () => {
  if(newName.value === "") {
    notificationStores.addNotification(t("needFillBrandName"), 'error');
    return;
  }

  marqueStore.createMarque(newName.value);
  newName.value = "";
}

</script>

<style scoped>

</style>